export const heroIdToJapaneseName: { [key: number]: string } = {
  1: "マイヤ",
  2: "バルモンド",
  3: "セイバー",
  4: "アリス",
  5: "ナナ",
  6: "ティグラル",
  7: "アルカード",
  8: "カリナ",
  9: "ガイ",
  10: "フランコ",
  11: "ベイン",
  12: "ブルーノ",
  13: "クリント",
  14: "ラファエル",
  15: "エウドラ",
  16: "子龍",
  17: "ファニー",
  18: "ライラ",
  19: "ミノタウル",
  20: "ロイン",
  21: "隼",
  22: "フレイヤ",
  23: "グールド",
  24: "ナタリア",
  25: "神楽",
  26: "シュウ",
  27: "悟空",
  28: "アルファ",
  29: "ルビー",
  30: "イスンシン",
  31: "モスコブ",
  32: "ジェイソン",
  33: "サイクロプス",
  34: "エスタス",
  35: "ヒルダ",
  36: "オーロラ",
  37: "ラプラプ",
  38: "サナ",
  39: "ロジャー",
  40: "キャリー",
  41: "ガトートカチャ",
  42: "ハーリー",
  43: "エレシル",
  44: "ガレック",
  45: "アルゴス",
  46: "オデット",
  47: "ランスロット",
  48: "ディガー",
  49: "ヒロス",
  50: "ザスク",
  51: "ハカート",
  52: "ファーサ",
  53: "ラズリー",
  54: "メタルヘッド",
  55: "アンジェラ",
  56: "ゴセン",
  57: "ヴァリル",
  58: "マーティス",
  59: "ウラノス",
  60: "ハナビ",
  61: "嫦娥",
  62: "カチャ",
  63: "セリナ",
  64: "アルダス",
  65: "クラウド",
  66: "ヴェル",
  67: "レオモルド",
  68: "星夢",
  69: "半蔵",
  70: "ベレリック",
  71: "ジミー",
  72: "デームス",
  73: "ハリス",
  74: "マイシータール",
  75: "カティタ",
  76: "ファラミス",
  77: "バターン",
  78: "クッフラー",
  79: "グレンジャー",
  80: "グィネヴィア",
  81: "エスメラルダ",
  82: "ディスラー",
  83: "エックス",
  84: "リン",
  85: "ディアス",
  86: "リリア",
  87: "玄覇",
  88: "マーシャ",
  89: "琥珀",
  90: "シルバンナ",
  91: "セシリオン",
  92: "カーミラ",
  93: "アテラス",
  94: "ポポル&クパ",
  95: "ゾン",
  96: "ローイー",
  97: "ベラ",
  98: "カレード",
  99: "バラッツ",
  100: "ブロディ",
  101: "イヴ",
  102: "マチルダ",
  103: "パキート",
  104: "グルー",
  105: "ビアトリクス",
  106: "フォビウス",
  107: "ニュート",
  108: "アウルス",
  109: "アモン",
  110: "バレンティナ",
  111: "イーディス",
  112: "フローラ",
  113: "寅",
  114: "メリッサ",
  115: "ザビエル",
  116: "ジュリアン",
  117: "フレッドリン",
  118: "ジョイ",
  119: "ノヴァリア",
  120: "アーロット",
  121: "イクシア",
  122: "ノーラン",
  123: "シーシー",
  124: "チップ",
  125: "燭心",
  126: "粛游",
  127: "ルーカス",
  128: "カレア",
  129: "則天",
  130: "アイーダ",
  131: "ソラ",
  132: "マルセル",
};

export function getJapaneseHeroName(heroId: number): string {
  return heroIdToJapaneseName[heroId] || "";
}
